import type { paths } from '@luxuryescapes/contract-svc-lux-loyalty'
import { mapLoyaltyEsimPromoCode } from 'api/mappers/loyalty/mapLoyaltyEsimBenefit'
import requestUtils from 'api/requestUtils'

type SuccessResponse = paths['/api/lux-loyalty/esim/order/{orderId}']['get']['responses']['200']['content']['application/json']

export type LoyaltyEsimPromoCodeResponse =
  | { status: 'success'; result: App.LoyaltyEsimBenefit }
  | { status: 'not_found' }
  | { status: 'not_ready' }
  | { status: 'generating' }
  | { status: 'error'; message: string }

/**
 * 200 → success (code exists or was just generated)
 * 404 → not_found (not eligible or cancelled)
 * 422 → not_ready (departure not within 7-day window)
 * 409 → generating (concurrent generation in progress)
 */
export default async function requestLoyaltyEsimPromoCode(orderId: string, customerId: string): Promise<LoyaltyEsimPromoCodeResponse> {
  try {
    const response = await requestUtils.get<SuccessResponse>(
      `/api/lux-loyalty/esim/order/${orderId}?customerId=${customerId}`,
      { credentials: 'include' },
    )
    return { status: 'success', result: mapLoyaltyEsimPromoCode(response.result) }
  } catch(error: any) {
    const errorStatus = error?.status
    if (errorStatus === 404) return { status: 'not_found' }
    if (errorStatus === 422) return { status: 'not_ready' }
    if (errorStatus === 409) return { status: 'generating' }
    return { status: 'error', message: error?.message ?? 'Unknown error' }
  }
}
